// shared state for showing product slide show / size guide / product slide show

import { ssrRef, watchEffect, watch } from '@nuxtjs/composition-api';
import { useRouter } from '../router';

const isOpen = ssrRef(false, 'is-open');
export function useSlideShow() {
  const { route } = useRouter();
  function toggle() {
    isOpen.value = !isOpen.value;
  }

  function close() {
    isOpen.value = false;
  }

  watchEffect(() => {
    if (process.server) {
      return;
    }

    window.document.body.classList.toggle('overflow-hidden', isOpen.value);
  });

  // close menu when navigating
  watch(route, () => {
    close();
  });

  return {
    isOpen,
    toggle,
    close,
  };
}
